import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { Text } from '@lmc/ui-kit/src/general'
import { FormCard, Descriptions } from '@lmc/ui-kit'
import { Resident, CarePlan } from '@lmc/ts-common'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { carePlansConstants } from 'locale/carePlans'

interface FluidTrackingCardProps {
  resident: Resident
  carePlan: CarePlan
}

const labelStyle = { width: 180 }

const FluidTrackingCard = ({ resident, carePlan }: FluidTrackingCardProps) => {
  const { t } = useTranslation(NAMESPACE.CARE_PLANS)
  const navigate = useNavigate()

  const handleChartNavigation = () => {
    const chartUrl = `/residents/${resident.id}/charts/fluids`
    navigate(chartUrl)
  }

  const intakeTarget = carePlan?.fluidTracking?.intakeTarget

  return (
    <>
      <FormCard
        title="Fluid tracking"
        rightChildren={
          <ChartLink onClick={handleChartNavigation}>
            {`View ${resident?.preferredName || resident.name.first}'s chart`}
          </ChartLink>
        }
      >
          <StyledDescriptions
            labelStyle={labelStyle}
            items={[
              {
                key: 1,
                label: <Text>{t(carePlansConstants.DAILY_INTAKE_TARGET)}</Text>,
                children: (
                  <Text>{intakeTarget}ml</Text>
                ),
              },
            ]}
            bordered
            column={1}
          />
      </FormCard>
    </>
  )
}

const ChartLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`

const StyledDescriptions = styled(Descriptions)`
  width: 320px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    width: 100%;
  }
`

export default FluidTrackingCard
